module.exports = __webpack_public_path__ + "img/save75.35e53cdd.png";